import React from "react";
import { setData } from "rivals/shared/utils/qa";

function YahooSports({ videoUrl }: { videoUrl: string }): React.JSX.Element {
  return (
    <iframe
      allow="autoplay; fullscreen; encrypted-media"
      allowFullScreen
      allowTransparency
      height="342"
      src="https://sports.yahoo.com/contract-implications-qbs-entering-final-001528069.html?format=embed"
      style={{ border: 0, overflow: "hidden" }}
      title={`yahoo-sports-video-${videoUrl}`}
      width="608"
      {...setData(`yahoo-sports-video`, videoUrl)}
    />
  );
}

export default YahooSports;
